export default __webpack_public_path__ + "static/media/expl-gradcam_09_DE.07e64f4b.png";